<template>
  <div class="finance-page main-wrapper">
    <div class="finance-page__inner px-2 px-md-3 pt-2">
      <h3 class="finance-page__title">
        {{ $t('deposit.deposit_form') }}
      </h3>
      <!-- <div
        v-if="depositBlockedMessage && !hasPendingDeposit"
        class="alert alert-warning mx-2 mx-md-3 mb-2"
        role="alert"
      >
        {{ depositBlockedMessage }}
      </div> -->
      <div class="finance-panel">
          <van-radio-group
            v-if="showModeSelector"
            v-model="depositMode"
            class="d-flex justify-content-center mb-2 mt-2"
            @change="onDepositModeChange"
          >
            <van-radio
              class="mx-3 my-1 finance-radio"
              name="auto"
              checked-color="#DD4DD1"
            >{{ $t('deposit.auto_payment') }}</van-radio>
            <van-radio
              class="mx-3 my-1 finance-radio"
              name="manual"
              checked-color="#DD4DD1"
            >{{ $t('deposit.manual_payment') }}</van-radio>
          </van-radio-group>
          <form>
            <!-- <h6 class="heading-small text-white">
                          {{
                              $store.state.language === "en"
                                  ? "Account information"
                                  : "အကောင့်ဆိုင်ရာ အချက်အလက်များ"
                          }}
                      </h6>
                      <span class="heading-small text-muted">{{
                                  $store.state.language === "en"
                                      ? "User's Balance"
                                      : "လက်ကျန်ငွေ"
                              }} - </span>
                      <span>
                        <b class="text-danger">{{ Number($store.state.amount).toLocaleString() }}</b>
                        <span class="text-muted pl-2">{{ $store.state.language === 'en' ? 'MMK' : 'ကျပ်' }}</span>
                      </span> -->
            <div>
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <label
                      class="finance-label"
                      for="input-username"
                    >{{ isMyanpayAutoDeposit ? $t('deposit.select_deposit_account') : $t('deposit.choose_payment_type') }}</label>
                    <p
                      v-if="isMyanpayAutoDeposit && !myanpayDepositAccounts.length"
                      class="text-warning text-sm mb-2"
                    >{{ $t('deposit.no_myanpay_wallets') }}</p>
                    <p
                      v-else-if="isMyanpayAutoDeposit && activeAccounts.length"
                      class="text-white text-sm mb-2"
                    >{{ $t('deposit.myanpay_wallets_hint') }}</p>
                    <AccountSelect
                      v-if="activeAccounts.length && !hasPendingDeposit"
                      :data="selected_account"
                      field="account_id"
                      :accounts="activeAccounts"
                    />
                    <span class="text-danger">{{
                      errors.account
                    }}</span>
                  </div>
                </div>
              </div>
              <div
                class="col-12 p-0 d-flex flex-wrap"
                v-if="selectedWalletDetails && !hasPendingDeposit"
              >
                <div class="col-12 py-2 pb-4 psp-payment-panel">
                  <h3 class="psp-payment-panel__title">
                    {{ selectedWalletDetails.name }}
                  </h3>
                  <p
                    v-if="isMyanpayAutoDeposit"
                    class="text-white mb-2"
                  >{{ $t('deposit.myanpay_transfer_hint') }}</p>
                  <div
                    v-if="selectedWalletDetails.account_name"
                    class="number-container d-flex py-3 my-2 text-white"
                  >
                    {{ $t('deposit.account_name') }}:&nbsp;
                    <h3 class="m-0 psp-payment-panel__value">
                      {{ selectedWalletDetails.account_name }}
                    </h3>
                    <span
                      class="ml-3 text-danger badge badge-danger"
                      @click="copyText(selectedWalletDetails.account_name)"
                    >Copy</span>
                  </div>
                  <div
                    v-if="selectedWalletDetails.number"
                    class="number-container d-flex py-3 my-2 text-white"
                  >
                    {{ $t('deposit.account_number') }}:&nbsp;
                    <h3 class="m-0 psp-payment-panel__value">
                      {{ selectedWalletDetails.number }}
                    </h3>
                    <span
                      class="ml-3 text-danger badge badge-danger"
                      @click="copyText(selectedWalletDetails.number)"
                    >Copy</span>
                  </div>
                </div>
              </div>
              <div
                class="col-12 p-0"
                v-if="pendingManualDeposit && !pspPayment"
              >
                <article class="pending-pay-card">
                  <div class="pending-pay-card__notice">
                    <span class="pending-pay-card__pulse" aria-hidden="true"></span>
                    <p>{{ $t('deposit.pending_manual_deposit') }}</p>
                  </div>

                  <header
                    v-if="pendingManualDeposit.account"
                    class="pending-pay-card__head"
                  >
                    <span class="pending-pay-card__kicker">{{ $t('deposit.transfer_to') }}</span>
                    <h3>{{ pendingManualDeposit.account.name }}</h3>
                  </header>

                  <div
                    v-if="pendingManualDeposit.amount"
                    class="pending-pay-card__amount"
                  >
                    <span>{{ $t('deposit.amount') }}</span>
                    <strong>
                      {{ Number(pendingManualDeposit.amount).toLocaleString() }}
                      <small>MMK</small>
                    </strong>
                  </div>

                  <dl class="pending-pay-card__rows">
                    <div
                      v-if="pendingManualDeposit.account && pendingManualDeposit.account.account_name"
                      class="pending-pay-card__row"
                    >
                      <dt>{{ $t('deposit.account_name') }}</dt>
                      <dd>{{ pendingManualDeposit.account.account_name }}</dd>
                      <button
                        type="button"
                        class="pending-pay-card__copy"
                        @click="copyText(pendingManualDeposit.account.account_name)"
                      >
                        <i class="far fa-copy" aria-hidden="true"></i>
                        Copy
                      </button>
                    </div>
                    <div
                      v-if="pendingManualDeposit.account && pendingManualDeposit.account.number"
                      class="pending-pay-card__row"
                    >
                      <dt>{{ $t('deposit.account_number') }}</dt>
                      <dd>{{ pendingManualDeposit.account.number }}</dd>
                      <button
                        type="button"
                        class="pending-pay-card__copy"
                        @click="copyText(pendingManualDeposit.account.number)"
                      >
                        <i class="far fa-copy" aria-hidden="true"></i>
                        Copy
                      </button>
                    </div>
                    <div
                      v-if="pendingManualDeposit.remark"
                      class="pending-pay-card__row"
                    >
                      <dt>{{ $t('deposit.last_digits') }}</dt>
                      <dd class="pending-pay-card__digits">{{ pendingManualDeposit.remark }}</dd>
                    </div>
                  </dl>

                  <button
                    type="button"
                    class="pending-pay-card__cancel"
                    :disabled="isCancelling"
                    @click="cancelPendingDeposit"
                  >
                    <i
                      class="fas fa-times"
                      aria-hidden="true"
                    ></i>
                    {{ isCancelling ? $t('deposit.cancelling') : $t('deposit.cancel_deposit') }}
                  </button>
                </article>
              </div>
              <div
                class="col-12 p-0 d-flex flex-wrap"
                v-if="pspPayment"
              >
                <div class="col-12 py-2 pb-4 psp-payment-panel">
                  <p
                    v-if="pspResumed"
                    class="text-warning mb-2"
                  >{{ $t('deposit.resumed_deposit') }}</p>
                  <h3 class="psp-payment-panel__title">
                    {{ pspPayment.wallet_provider_name || pspPayment.bank_name }}
                  </h3>
                  <div
                    v-if="pspPayment.amount"
                    class="number-container d-flex py-3 my-2 text-white"
                  >
                    {{ $t('deposit.amount') }}:&nbsp;
                    <h3 class="m-0 psp-payment-panel__value">
                      {{ Number(pspPayment.amount).toLocaleString() }} MMK
                    </h3>
                  </div>
                  <div
                    v-if="pspPayment.transaction_code"
                    class="number-container d-flex flex-wrap py-3 my-2 text-white align-items-center"
                  >
                    {{ $t('deposit.transaction_code') }}:&nbsp;
                    <h3 class="m-0 mr-2 psp-payment-panel__value psp-payment-panel__value--break">
                      {{ pspPayment.transaction_code }}
                    </h3>
                    <span
                      class="text-danger badge badge-danger"
                      @click="copyText(pspPayment.transaction_code)"
                    >Copy</span>
                  </div>
                  <div
                    v-if="pspPayment.transaction_no"
                    class="number-container d-flex flex-wrap py-3 my-2 text-white align-items-center"
                  >
                    {{ $t('deposit.transaction_no') }}:&nbsp;
                    <h3 class="m-0 psp-payment-panel__value">
                      {{ pspPayment.transaction_no }}
                    </h3>
                  </div>

                  <template v-if="isMyanpayDeposit">
                    <p class="text-white mb-2">{{ $t('deposit.myanpay_hint') }}</p>
                    <div
                      v-if="myanpayWalletDetails?.account_name"
                      class="number-container d-flex py-3 my-2 text-white"
                    >
                      {{ $t('deposit.account_name') }}:&nbsp;
                      <h3 class="m-0 psp-payment-panel__value">
                        {{ myanpayWalletDetails.account_name }}
                      </h3>
                      <span
                        class="ml-3 text-danger badge badge-danger"
                        @click="copyText(myanpayWalletDetails.account_name)"
                      >Copy</span>
                    </div>
                    <div
                      v-if="myanpayWalletDetails?.number"
                      class="number-container d-flex py-3 my-2 text-white"
                    >
                      {{ $t('deposit.account_number') }}:&nbsp;
                      <h3 class="m-0 psp-payment-panel__value">
                        {{ myanpayWalletDetails.number }}
                      </h3>
                      <span
                        class="ml-3 text-danger badge badge-danger"
                        @click="copyText(myanpayWalletDetails.number)"
                      >Copy</span>
                    </div>
                    <div class="form-group mt-3">
                      <label class="finance-label">
                        {{ $t('deposit.last_digits') }}
                      </label>
                      <input
                        type="tel"
                        inputmode="numeric"
                        pattern="[0-9]*"
                        class="form-control finance-input"
                        v-model="myanpayDigits"
                        maxlength="5"
                        placeholder="12345"
                        @input="myanpayDigits = myanpayDigits.replace(/\D/g, '').slice(0, 5)"
                      />
                    </div>
                    <div class="d-flex flex-wrap mt-2">
                      <button
                        type="button"
                        class="btn btn-warning mr-2 mb-2 px-4"
                        :disabled="isVerifyingDigits"
                        @click="verifyMyanpayDeposit"
                      >
                        {{ isVerifyingDigits ? $t('deposit.verifying') : $t('deposit.verify_payment') }}
                      </button>
                      <button
                        type="button"
                        class="btn btn-sm btn-outline-light mb-2"
                        :disabled="isCancelling"
                        @click="cancelPendingDeposit"
                      >{{ isCancelling ? $t('deposit.cancelling') : $t('deposit.cancel') }}</button>
                    </div>
                  </template>

                  <template v-else-if="isV5Payment">
                    <p class="text-white mb-3">{{ $t('deposit.payment_page_hint') }}</p>
                    <div class="d-flex flex-wrap mt-2">
                      <a
                        :href="pspPayment.page_url"
                        class="btn btn-warning mr-2 mb-2 px-4"
                      >{{ $t('deposit.pay_now') }}</a>
                      <button
                        type="button"
                        class="btn btn-sm btn-outline-light mb-2"
                        :disabled="isCancelling"
                        @click="cancelPendingDeposit"
                      >{{ isCancelling ? $t('deposit.cancelling') : $t('deposit.cancel') }}</button>
                    </div>
                  </template>

                  <template v-else>
                    <p class="text-white mb-2">{{ $t('deposit.transfer_to') }}</p>
                    <div
                      v-if="pspPayment.bank_account_name"
                      class="number-container d-flex py-3 my-2 text-white"
                    >
                      {{ $t('deposit.account_name') }}:
                      <h3 class="m-0 psp-payment-panel__value">
                        &nbsp;{{ pspPayment.bank_account_name }}
                      </h3>
                    </div>
                    <div
                      v-if="pspPayment.bank_account_number"
                      class="number-container d-flex py-3 my-2 text-white"
                    >
                      {{ $t('deposit.account_number') }}:&nbsp;
                      <h3 class="m-0 psp-payment-panel__value">
                        {{ pspPayment.bank_account_number }}
                      </h3>
                      <span
                        class="ml-5 text-danger badge badge-danger"
                        @click="copyText(pspPayment.bank_account_number)"
                      >Copy</span>
                    </div>
                    <div
                      v-if="pspPayment.reference"
                      class="number-container d-flex py-3 my-2 text-white"
                    >
                      {{ $t('deposit.reference') }}:&nbsp;
                      <h3 class="m-0 psp-payment-panel__value">
                        {{ pspPayment.reference }}
                      </h3>
                      <span
                        class="ml-5 text-danger badge badge-danger"
                        @click="copyText(pspPayment.reference)"
                      >Copy</span>
                    </div>
                    <div class="d-flex flex-wrap mt-3">
                      <a
                        v-if="pspPayment.qr_url"
                        :href="pspPayment.qr_url"
                        target="_blank"
                        rel="noopener"
                        class="btn btn-sm btn-warning mr-2 mb-2"
                      >{{ $t('deposit.open_qr') }}</a>
                      <button
                        type="button"
                        class="btn btn-sm btn-outline-light mb-2"
                        :disabled="isCancelling"
                        @click="cancelPendingDeposit"
                      >{{ isCancelling ? $t('deposit.cancelling') : $t('deposit.cancel') }}</button>
                    </div>
                  </template>

                  <template v-if="!isMyanpayDeposit">
                    <p class="text-white text-sm mt-2">{{ $t('deposit.waiting_confirm') }}</p>
                    <p
                      v-if="isCheckingStatus"
                      class="text-white text-sm mt-2 mb-0"
                    >{{ $t('deposit.checking_status') }}</p>
                  </template>
                </div>
              </div>
            </div>
            <!-- <hr class="my-4" />d -->
            <div>
              <div class="row">
                <!-- <div class="col-lg-6">
                                  <div class="form-group">
                                      <label class="form-control-label">{{
                                          $store.state.language === "en"
                                              ? "Screenshot"
                                              : "ငွေပေးချေမူ ဓာက်ပုံ"
                                      }}</label>

                                      <div class="custom-file d-flex">
                                          <van-uploader
                                              class="mx-auto"
                                              v-model="imageUploader"
                                              :max-count="1"
                                          />
                                      </div>
                                      <span class="text-danger">{{
                                          errors.image
                                      }}</span>
                                  </div>
                              </div> -->
                <div
                  v-if="!hasPendingDeposit"
                  class="col-12"
                >
                  <div class="form-group">
                    <label
                      class="finance-label"
                      for="input-email"
                    >{{ $t('deposit.amount') }}</label>
                    <span
                      class="text-danger text-xs"
                      style="color: #DD4DD1 !important"
                    > {{ $t('deposit.minimum_deposit') }}</span>
                    <input
                      type="number"
                      id="input-email"
                      class="form-control finance-input"
                      v-model="depositData.amount"
                      placeholder="Amount"
                    />
                    <span class="text-danger">{{
                      errors.amount
                    }}</span>




                  </div>
                  <div class="d-flex col-12 flex-wrap p-0 mb-4">
                    <span v-show="false">{{ testing }} </span>
                    <div
                      class="col-4 p-0 pr-1 py-1"
                      @click="depositCustomAmount(2000)"
                    >
                      <div
                        class="amount-cont text-white py-2 text-center w-100"
                        :class="depositData.amount === 2000 ? 'active' : ''"
                      >
                        2,000 MMK
                      </div>
                    </div>

                    <div
                      class="col-4 p-0 px-1 py-1"
                      @click="depositCustomAmount(5000)"
                    >
                      <div
                        class="amount-cont text-white py-2 text-center w-100"
                        :class="depositData.amount === 5000 ? 'active' : ''"
                      >
                        5,000 MMK
                      </div>
                    </div>

                    <div
                      class="col-4 p-0 pl-1 py-1"
                      @click="depositCustomAmount(10000)"
                    >
                      <div
                        class="amount-cont text-white py-2 text-center w-100"
                        :class="depositData.amount === 10000 ? 'active' : ''"
                      >
                        10,000 MMK
                      </div>
                    </div>

                    <div
                      class="col-4 p-0 pr-1 py-1"
                      @click="depositCustomAmount(30000)"
                    >
                      <div
                        class="amount-cont text-white py-2 text-center w-100"
                        :class="depositData.amount === 30000 ? 'active' : ''"
                      >
                        30,000 MMK
                      </div>
                    </div>

                    <div
                      class="col-4 p-0 px-1 py-1"
                      @click="depositCustomAmount(50000)"
                    >
                      <div
                        class="amount-cont text-white py-2 text-center w-100"
                        :class="depositData.amount === 50000 ? 'active' : ''"
                      >
                        50,000 MMK
                      </div>
                    </div>

                    <div
                      class="col-4 p-0 pl-1 py-1"
                      @click="depositCustomAmount(100000)"
                    >
                      <div
                        class="amount-cont text-white py-2 text-center w-100"
                        :class="depositData.amount === 100000 ? 'active' : ''"
                      >
                        100,000 MMK
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="(isManualDeposit || isMyanpayAutoDeposit) && !hasPendingDeposit"
            >
              <div class="form-group">
                <label class="finance-label">{{
                  $t('deposit.last_digits')
                }}</label>
                <input
                  type="tel"
                  inputmode="numeric"
                  pattern="[0-9]*"
                  id="input-email"
                  class="form-control finance-input"
                  :placeholder="$t('deposit.last_digits')"
                  v-model="depositDigits"
                  @input="depositDigits = depositDigits.replace(/\D/g, '').slice(0, 5)"
                  maxlength="5"
                />
                <span class="text-danger">{{
                  errors.remark
                }}</span>
              </div>
            </div>
            <div>
              <div
                v-if="!hasPendingDeposit"
                class="form-group mb-3"
              >
                <label class="finance-label">{{ $store.state.language === 'en' ? 'Promotion' : 'ပရိုမိုးရှင်း' }}</label>
                <select
                  v-model="selectedPromotionId"
                  class="form-control finance-input"
                >
                  <option value="">
                    {{ $store.state.language === 'en' ? 'Do not participate in any promotion' : 'ပရိုမိုးရှင်း မပါဝင်ပါ' }}
                  </option>
                  <option
                    v-for="promotion in promotions"
                    :key="promotion.id"
                    :value="promotion.id"
                    :disabled="promotion.claim_once_per_user && promotion.claimed"
                  >
                    {{ promotionOptionLabel(promotion) }}
                  </option>
                </select>
                <span
                  v-if="selectedPromotion && selectedPromotion.claim_once_per_user && selectedPromotion.claimed"
                  class="text-danger d-block mt-1"
                >
                  {{ $store.state.language === 'en'
                    ? 'You have already claimed this promotion.'
                    : 'ဤပရိုမိုးရှင်းကို ရယူပြီးသားဖြစ်ပါသည်။' }}
                </span>
                <span
                  v-else-if="claimableAmountError"
                  class="text-danger d-block mt-1"
                >
                  {{ claimableAmountError }}
                </span>
                <button
                  v-if="isNoDepositPromotion"
                  type="button"
                  class="btn finance-btn-primary mt-2"
                  :disabled="isClaimingFree || (selectedPromotion && selectedPromotion.claimed)"
                  @click="claimFreePromotion"
                >
                  {{ selectedPromotion && selectedPromotion.claimed
                    ? ($store.state.language === 'en' ? 'Already claimed' : 'ရယူပြီးသား')
                    : ($store.state.language === 'en' ? 'Claim promotion' : 'ပရိုမိုးရှင်း ရယူမည်') }}
                </button>
              </div>


              <div
                v-if="!hasPendingDeposit"
                class="form-group"
              >
                <button
                  type="button"
                  class="btn finance-btn-primary"
                  @click="sendDepositData"
                >
                  <div v-if="!isConfirm">
                    {{ $t('deposit.submit') }}
                  </div>

                  <Loading
                    color="#ffffff"
                    v-if="isConfirm"
                    size="24"
                    class="px-4 py-0"
                  />
                </button>
              </div>
            </div>

          </form>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { Toast, Dialog, Loading } from 'vant';
import { mapActions } from 'vuex';
import AccountSelect from './components/AccountSelect.vue';
import {
  defaultDepositMode,
  applyAutoDepositResponse,
  applyPendingDepositFromConfig,
  resolveAutoDepositAccounts,
  enrichWalletAccounts,
  mapMyanpayDepositAccounts,
  normalizeProvider,
  isMyanpayDepositProvider,
  isMyanpayPayment,
  isKpayOrWavePayment,
  findManualAccountForWallet,
} from '../../utils/paymentBanks';

export default {
  components: { AccountSelect, Loading },
  data() {
    return {
      selected_account: {},
      accounts: [],
      pspBanks: [],
      myanpayDepositAccounts: [],
      account: [],
      paymentSettings: {},
      depositMode: 'manual',
      pspPayment: null,
      pspDepositId: null,
      pspResumed: false,
      autoDepositProvider: 'mcpay',
      myanpayDigits: '',
      isVerifyingDigits: false,
      pendingManualDeposit: null,
      isCancelling: false,
      isCheckingStatus: false,
      statusPollTimer: null,
      imageUploader: [],
      depositData: {
        is_bonus: false,
      },
      depositDigits: '',
      is_promotion: true,
      depositBlockedMessage: null,
      activePromotionSummary: null,
      promotions: [],
      selectedPromotionId: '',
      isClaimingFree: false,
      errors: {},
      isConfirm: false,
      testing: 0,
    };
  },
  methods: {
    ...mapActions(['fetchUser']),
    claimableAmount(promotion) {
      const amount = Number(promotion?.claimable_amount);
      return Number.isFinite(amount) ? amount : 0;
    },
    formatMoney(value) {
      return Number(value || 0).toLocaleString();
    },
    promotionOptionLabel(promotion) {
      const parts = [promotion.name];
      const minimum = this.claimableAmount(promotion);
      if (minimum) parts.push(Number(minimum).toLocaleString());
      if (promotion.claim_once_per_user && promotion.claimed) {
        parts.push(this.$store.state.language === 'en' ? 'Claimed' : 'ရယူပြီး');
      }
      return parts.join(' - ');
    },
    async fetchPromotions() {
      try {
        const res = await axios.get('/promotions?active=1', {
          headers: this.authHeaders(),
        });
        const raw = res.data.data || res.data;
        this.promotions = Array.isArray(raw) ? raw : [];
      } catch (error) {
        this.promotions = [];
      }
    },
    async claimFreePromotion() {
      const promotion = this.selectedPromotion;
      if (!promotion?.id || this.isClaimingFree || promotion.claimed) return;
      this.isClaimingFree = true;
      try {
        await axios.post(`/user/promotions/${promotion.id}/claim`, {}, {
          headers: this.authHeaders(),
        });
        Toast.success('Success');
        await this.fetchPromotions();
        await this.fetchUser();
      } catch (error) {
        Toast.fail(error?.response?.data?.message || 'Fail');
      } finally {
        this.isClaimingFree = false;
      }
    },
    depositCustomAmount(number) {
      this.depositData.amount = number;
      this.testing = number;
    },
    copyText(text) {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      Toast.success(
        this.$store.state.language === 'en'
          ? 'Copied'
          : 'ကူးယူပြီးပါပြီ',
      );
    },
    onDepositModeChange() {
      this.selected_account.account_id = null;
      this.account = [];
      this.errors = {};
      this.depositDigits = '';

      if (
        this.depositMode === 'auto'
        && isMyanpayDepositProvider(this.paymentSettings)
        && !this.myanpayDepositAccounts.length
      ) {
        this.fetchMyanpayDepositWallets();
      }
    },
    async applyMyanpayDepositWalletsFromConfig(config = {}) {
      const settings = config.payment_settings || this.paymentSettings || {};

      if (!isMyanpayDepositProvider(settings)) {
        this.myanpayDepositAccounts = [];
        return;
      }

      const myanpay = config.providers?.myanpay || {};
      const wallets = myanpay.myanpay_wallets || myanpay.deposit_accounts || [];

      if (wallets.length) {
        this.myanpayDepositAccounts = mapMyanpayDepositAccounts(wallets);
      }

      if (this.myanpayDepositAccounts.length === 0) {
        await this.fetchMyanpayDepositWallets();
      }
    },
    async fetchMyanpayDepositWallets() {
      try {
        const res = await axios.get('/myanpay/deposit-wallets', {
          headers: this.authHeaders(),
        });
        this.myanpayDepositAccounts = mapMyanpayDepositAccounts(res.data?.data || []);
      } catch (error) {
        console.log(error);
      }
    },
    findSelectedMyanpayDepositAccount() {
      const selectedId = this.selected_account.account_id;

      return this.myanpayDepositAccounts.find((item) => item.id === selectedId) || null;
    },
    applyPspPayment(result) {
      if (!result) {
        return;
      }

      this.pspPayment = result.payment;
      this.pspDepositId = result.depositId;
      this.pspResumed = result.resumed;
      this.autoDepositProvider = result.provider || result.payment?.provider || 'mcpay';
      this.myanpayDigits = '';

      if (isMyanpayPayment(result.payment, this.autoDepositProvider)) {
        this.stopStatusPolling();
        this.isCheckingStatus = false;
      } else {
        this.startStatusPolling();
      }
    },
    clearPspPayment() {
      this.stopStatusPolling();
      this.pspPayment = null;
      this.pspDepositId = null;
      this.pspResumed = false;
      this.autoDepositProvider = 'mcpay';
      this.myanpayDigits = '';
      this.isVerifyingDigits = false;
      this.pendingManualDeposit = null;
      this.isCheckingStatus = false;
    },
    applyManualPending(pending) {
      if (!pending || !pending.id) {
        return;
      }

      this.pendingManualDeposit = pending;
    },
    authHeaders() {
      return {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      };
    },
    formatDepositErrorMessage(message) {
      if (!message) {
        return this.$store.state.language === 'en'
          ? 'Unable to process deposit'
          : 'ငွေသွင်း၍ မရသေးပါ။';
      }

      if (/already been used|အသုံးပြုပြီးသား/i.test(message)) {
        return this.$t('deposit.duplicate_transaction_digits');
      }

      return message;
    },
    async cancelPendingDeposit() {
      const depositId = this.pspDepositId || this.pendingManualDeposit?.id;
      if (!depositId) {
        this.clearPspPayment();
        return;
      }

      try {
        await Dialog.confirm({
          message: this.$t('deposit.cancel_deposit_confirm'),
          confirmButtonText: this.$t('deposit.cancel'),
          cancelButtonText: this.$store.state.language === 'en' ? 'Go Back' : 'နောက်သို့ပြန်သွားမည်။',
        });
      } catch (error) {
        return;
      }

      this.isCancelling = true;
      try {
        await axios.post(`/deposits/${depositId}/cancel`, {}, {
          headers: this.authHeaders(),
        });
        this.clearPspPayment();
        Toast.success(this.$t('deposit.deposit_cancelled'));
      } catch (error) {
        const errorMessage = error.response?.data?.message
          || (this.$store.state.language === 'en'
            ? 'Unable to cancel deposit'
            : 'ငွေသွင်း ပယ်ဖျက်၍ မရပါ။');
        Dialog.alert({
          message: errorMessage,
          confirmButtonText: this.$store.state.language === 'en'
            ? 'Go Back'
            : 'နောက်သို့ပြန်သွားမည်။',
        });
      } finally {
        this.isCancelling = false;
      }
    },
    startStatusPolling() {
      this.stopStatusPolling();
      if (!this.pspDepositId) {
        return;
      }

      this.isCheckingStatus = true;
      this.checkPspDepositStatus();
      this.statusPollTimer = setInterval(() => {
        this.checkPspDepositStatus();
      }, 15000);
    },
    stopStatusPolling() {
      if (this.statusPollTimer) {
        clearInterval(this.statusPollTimer);
        this.statusPollTimer = null;
      }
    },
    async verifyMyanpayDeposit() {
      if (!this.pspDepositId) {
        return;
      }

      if (!this.myanpayDigits || this.myanpayDigits.length !== 5) {
        Dialog.alert({
          message: this.$t('deposit.enter_transaction_digits'),
          confirmButtonText: this.$store.state.language === 'en' ? 'Go Back' : 'နောက်သို့ပြန်သွားမည်။',
        });
        return;
      }

      this.isVerifyingDigits = true;
      try {
        await axios.post(`/myanpay/deposits/${this.pspDepositId}/verify`, {
          digits: this.myanpayDigits,
        }, {
          headers: this.authHeaders(),
        });

        this.clearPspPayment();
        await this.fetchUser();
        Toast.success(this.$t('deposit.deposit_confirmed'));
      } catch (error) {
        Dialog.alert({
          message: this.formatDepositErrorMessage(error.response?.data?.message),
          confirmButtonText: this.$store.state.language === 'en' ? 'Go Back' : 'နောက်သို့ပြန်သွားမည်။',
        });
      } finally {
        this.isVerifyingDigits = false;
      }
    },
    async checkPspDepositStatus() {
      if (!this.pspDepositId || this.isMyanpayDeposit) {
        return;
      }

      try {
        const res = await axios.get(`/psp/deposits/${this.pspDepositId}/status`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });

        const deposit = res.data?.data?.deposit;
        if (deposit?.status === 'confirm') {
          this.stopStatusPolling();
          this.isCheckingStatus = false;
          this.clearPspPayment();
          await this.fetchUser();
          Toast.success(this.$t('deposit.deposit_confirmed'));
        } else if (deposit?.status === 'fail') {
          this.stopStatusPolling();
          this.isCheckingStatus = false;
          this.pspResumed = false;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async fetchAccounts() {
      try {
        const res = await axios.get('/accounts', {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });
        this.accounts = res.data.data;
        this.is_promotion = res.data.is_promotion;
        this.depositBlockedMessage = res.data.deposit_blocked_message || null;
        this.activePromotionSummary = res.data.active_promotion || null;
        this.paymentSettings = res.data.payment_settings || {};
        this.depositMode = defaultDepositMode(this.paymentSettings);

        if (res.data.pending_deposit?.id) {
          this.applyManualPending(res.data.pending_deposit);
        }

        if (res.data.myanpay_deposit_wallets?.length) {
          this.myanpayDepositAccounts = mapMyanpayDepositAccounts(res.data.myanpay_deposit_wallets);
        }

        if (
          this.paymentSettings.auto_deposit
          || this.paymentSettings.auto_deposit_enabled
          || isMyanpayDepositProvider(this.paymentSettings)
        ) {
          await this.fetchAutoPaymentConfig();
        }
      } catch (error) {
        console.log(error);
      }
    },
    async fetchAutoPaymentConfig() {
      try {
        const res = await axios.get('/auto-payment/config', {
          headers: this.authHeaders(),
        });

        if (res.data.payment_settings) {
          this.paymentSettings = res.data.payment_settings;
        }

        this.pspBanks = enrichWalletAccounts(
          resolveAutoDepositAccounts(res.data),
          this.accounts,
          res.data.providers?.myanpay || {},
        );
        await this.applyMyanpayDepositWalletsFromConfig(res.data);

        const pending = applyPendingDepositFromConfig(res.data.pending_deposit);
        if (pending) {
          this.applyPspPayment(pending);
        }
      } catch (error) {
        try {
          const res = await axios.get('/psp/banks', {
            headers: this.authHeaders(),
          });
          if (res.data.payment_settings) {
            this.paymentSettings = res.data.payment_settings;
          }
          this.pspBanks = enrichWalletAccounts(
            resolveAutoDepositAccounts({
              payment_settings: res.data.payment_settings,
              providers: {
                mcpay: {
                  configured: res.data.configured,
                  banks: res.data.banks || [],
                },
              },
            }),
            this.accounts,
          );

          if (isMyanpayDepositProvider(res.data.payment_settings || {})) {
            await this.fetchMyanpayDepositWallets();
          }

          const pending = applyPendingDepositFromConfig(res.data.pending_deposit);
          if (pending) {
            this.applyPspPayment(pending);
          }
        } catch (fallbackError) {
          console.log(fallbackError);
        }
      }
    },
    async sendDepositData() {
      try {
        await this.fetchUser();
        await this.fetchAccounts();
        this.errors = {};
        if (this.depositBlockedMessage) {
          this.errors.amount = this.depositBlockedMessage;
          return false;
        }
        if (this.isMyanpayAutoDeposit) {
          if (!this.myanpayDepositAccounts.length) {
            this.errors.account = this.$t('deposit.no_myanpay_wallets');
            return false;
          }
          if (!this.findSelectedMyanpayDepositAccount()) {
            this.errors.account = this.$t('deposit.select_deposit_account');
            return false;
          }
        } else if (!this.selected_account.account_id) {
          this.errors.account = this.$store.state.language === 'en'
            ? 'Please pick account type'
            : 'အကောင့်အမျိုးအစား ရွေးချယ်ပေးပါ။';
          return false;
        }

        if (!this.depositData.amount) {
          this.errors.amount = this.$store.state.language === 'en'
            ? 'Please enter amount'
            : 'ငွေပမာဏထည့်ပေးပါ။';
          return false;
        }
        if (this.depositData.amount < 2000) {
          this.errors.amount = this.$store.state.language === 'en'
            ? 'Please enter at least 2000 MMK'
            : 'ငွေပမာဏအနည်းဆုံး 2000 ထည့်ပေးပါ။';
          return false;
        }
        if (this.claimableAmountError) {
          this.errors.amount = this.claimableAmountError;
          return false;
        }
        if (this.selectedPromotion && this.selectedPromotion.claimed) {
          this.errors.amount = this.$store.state.language === 'en'
            ? 'You have already claimed this promotion.'
            : 'ဤပရိုမိုးရှင်းကို ရယူပြီးသားဖြစ်ပါသည်။';
          return false;
        }
        if (this.isNoDepositPromotion) {
          this.errors.amount = this.$store.state.language === 'en'
            ? 'This promotion is claimed without a deposit. Use the claim button.'
            : 'ဤပရိုမိုးရှင်းကို ငွေမသွင်းဘဲ ရယူနိုင်ပါသည်။';
          return false;
        }

        if (this.isManualDeposit || this.isMyanpayAutoDeposit) {
          if (!this.depositDigits || this.depositDigits.length !== 5) {
            this.errors.remark = this.$t('deposit.enter_transaction_digits');
            return false;
          }
        }

        if (this.isMyanpayAutoDeposit) {
          const walletAccount = this.findSelectedMyanpayDepositAccount();
          if (!walletAccount) {
            this.errors.account = this.$t('deposit.select_deposit_account');
            return false;
          }
        }

        this.isConfirm = true;
        const payload = {
          amount: this.depositData.amount,
          is_bonus: this.depositData.is_bonus,
          date: this.currentTime,
          promotion_id: this.selectedPromotionId || null,
        };

        if (this.isAutoDeposit) {
          if (this.isMyanpayAutoDeposit) {
            const walletAccount = this.findSelectedMyanpayDepositAccount();
            payload.bank_code = walletAccount.bank_code;
            payload.wallet_provider = walletAccount.wallet_provider;
            payload.wallet_account = walletAccount.number;
          } else {
            payload.bank_code = this.selected_account.account_id;
          }
          payload.use_psp = true;
        } else {
          payload.account_id = this.selected_account.account_id;
          payload.remark = this.depositDigits;
        }

        const res = await axios.post('/deposits', payload, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });

        if (this.isAutoDeposit && res.data.payment) {
          const paymentResult = applyAutoDepositResponse(res.data);

          if (
            isMyanpayPayment(paymentResult?.payment, paymentResult?.provider)
            && paymentResult?.depositId
            && this.depositDigits
          ) {
            try {
              await axios.post(`/myanpay/deposits/${paymentResult.depositId}/verify`, {
                digits: this.depositDigits,
              }, {
                headers: this.authHeaders(),
              });
              this.clearPspPayment();
              this.depositData = { is_bonus: false };
              this.depositDigits = '';
              this.selected_account.account_id = null;
              await this.fetchUser();
              Toast.success(this.$t('deposit.deposit_confirmed'));
              this.isConfirm = false;
              return true;
            } catch (verifyError) {
              this.applyPspPayment(paymentResult);
              this.myanpayDigits = this.depositDigits;
              this.depositData = { is_bonus: false };
              Dialog.alert({
                message: this.formatDepositErrorMessage(verifyError.response?.data?.message),
                confirmButtonText: this.$store.state.language === 'en' ? 'Go Back' : 'နောက်သို့ပြန်သွားမည်။',
              });
              this.isConfirm = false;
              return false;
            }
          }

          this.applyPspPayment(paymentResult);
          this.depositData = { is_bonus: false };

          if (
            paymentResult?.provider === 'mcpay'
            && paymentResult?.payment?.page_url
            && !res.data.resumed
          ) {
            Toast.success(this.$t('deposit.redirecting_payment'));
            window.location.href = paymentResult.payment.page_url;
            return true;
          }

          Toast.success(
            res.data.resumed
              ? this.$t('deposit.resumed_deposit')
              : (isMyanpayPayment(paymentResult?.payment, paymentResult?.provider)
                ? this.$t('deposit.myanpay_hint')
                : (paymentResult?.payment?.page_url
                  ? this.$t('deposit.payment_page_hint')
                  : (this.$store.state.language === 'en'
                    ? 'Transfer to the account shown below'
                    : 'အောက်ပါအကောင့်သို့ ငွေလွဲပေးပါ'))),
          );
        } else {
          this.applyManualPending({
            id: res.data.data.id,
            amount: res.data.data.amount,
            remark: res.data.data.remark,
            date: res.data.data.date,
            status: res.data.data.status || 'pending',
            account: this.selectedWalletDetails ? {
              id: this.selected_account.account_id,
              name: this.selectedWalletDetails.name,
              account_name: this.selectedWalletDetails.account_name,
              number: this.selectedWalletDetails.number,
            } : null,
          });
          this.depositData = { is_bonus: false };
          this.depositDigits = '';
          Toast.success(
            this.$store.state.language === 'en'
              ? 'Success'
              : 'အောင်မြင်သည်။',
          );
        }
        this.isConfirm = false;
      } catch (error) {
        this.isConfirm = false;
        const pending = error.response?.data?.pending_deposit;
        if (pending?.provider === 'psp' || pending?.provider === 'myanpay' || pending?.payment) {
          await this.fetchAutoPaymentConfig();
        } else if (pending?.id) {
          this.applyManualPending(pending);
        }
        Dialog.alert({
          message: this.formatDepositErrorMessage(error.response?.data?.message),
          confirmButtonText:
            this.$store.state.language === 'en'
              ? 'Go Back'
              : 'နောက်သို့ပြန်သွားမည်။',
        });
      }
      return true;
    },
    createDateWithTimeZone() {
      const moment = require('moment-timezone');
      const dateInTimeZone = moment.tz(new Date(), 'Asia/Rangoon');
      // Extract individual components from moment object
      const year = dateInTimeZone.year();
      const month = dateInTimeZone.month();
      const day = dateInTimeZone.date();
      const hour = dateInTimeZone.hour();
      const minute = dateInTimeZone.minute();
      const second = dateInTimeZone.second();
      const millisecond = dateInTimeZone.millisecond();

      // Create a new Date object with the extracted components
      const newDateObject = new Date(year, month, day, hour, minute, second, millisecond);
      return newDateObject;
    },
  },
  watch: {
    'selected_account.account_id': function () {
      if (this.isManualDeposit) {
        this.account = this.accounts.filter(
          (account) => account.id === this.selected_account.account_id,
        );
      } else {
        this.account = [];
      }
      if (!this.pspResumed && !this.pendingManualDeposit) {
        this.stopStatusPolling();
        this.pspPayment = null;
        this.pspDepositId = null;
      }
    },
  },
  beforeDestroy() {
    this.stopStatusPolling();
  },
  computed: {
    isAutoDeposit() {
      return this.depositMode === 'auto';
    },
    isManualDeposit() {
      return this.depositMode === 'manual';
    },
    showModeSelector() {
      return this.paymentSettings.auto_deposit && this.paymentSettings.manual_deposit;
    },
    isMyanpayDeposit() {
      return Boolean(
        this.pspPayment
          && isMyanpayPayment(this.pspPayment, this.autoDepositProvider),
      );
    },
    isV5Payment() {
      return !this.isMyanpayDeposit && Boolean(
        this.pspPayment?.page_url
          || this.pspPayment?.api_version === 'v5',
      );
    },
    hasPendingDeposit() {
      return Boolean(this.pspPayment || this.pendingManualDeposit);
    },
    selectedPromotion() {
      return this.promotions.find((promotion) => promotion.id == this.selectedPromotionId) || null;
    },
    isNoDepositPromotion() {
      const promotion = this.selectedPromotion;
      if (!promotion) return false;
      const requiresDeposit = promotion.requires_deposit;
      return requiresDeposit === false || requiresDeposit === 0 || requiresDeposit === '0';
    },
    claimableAmountError() {
      const promotion = this.selectedPromotion;
      if (!promotion || this.isNoDepositPromotion) return '';
      const minimum = this.claimableAmount(promotion);
      if (!minimum || Number(this.depositData.amount || 0) >= minimum) return '';
      const display = Number(minimum).toLocaleString();
      return this.$store.state.language === 'en'
        ? `The minimum deposit amount for this promotion is ${display}.`
        : `ဤပရိုမိုးရှင်းအတွက် အနည်းဆုံး ငွေသွင်းပမာဏမှာ ${display} ဖြစ်ပါသည်။`;
    },
    isMyanpayAutoDeposit() {
      if (!this.isAutoDeposit) {
        return false;
      }

      return isMyanpayDepositProvider(this.paymentSettings);
    },
    activeAccounts() {
      if (this.isMyanpayAutoDeposit && this.myanpayDepositAccounts.length) {
        return this.myanpayDepositAccounts;
      }

      return this.isAutoDeposit ? this.pspBanks : this.accounts;
    },
    selectedWalletDetails() {
      const selectedId = this.selected_account.account_id;
      if (!selectedId || this.hasPendingDeposit) {
        return null;
      }

      if (this.isMyanpayAutoDeposit) {
        const selected = this.findSelectedMyanpayDepositAccount();
        if (!selected) {
          return null;
        }

        return {
          name: selected.wallet_provider_name || selected.name,
          account_name: selected.account_name,
          number: selected.number,
        };
      }

      const selected = this.activeAccounts.find((item) => item.id === selectedId);
      if (!selected || !isKpayOrWavePayment(selected)) {
        return null;
      }

      if (this.isManualDeposit) {
        return {
          name: selected.name,
          account_name: selected.account_name,
          number: selected.number,
        };
      }

      if (selected.wallet_provider && !selected.number) {
        return {
          name: selected.name,
          assign_on_submit: true,
        };
      }

      const manualAccount = findManualAccountForWallet(
        this.accounts,
        selected.wallet_provider || selected.id || selected.name,
      );

      if (manualAccount) {
        return {
          name: selected.name,
          account_name: manualAccount.account_name,
          number: manualAccount.number,
        };
      }

      if (selected.account_name && selected.number) {
        return {
          name: selected.name,
          account_name: selected.account_name,
          number: selected.number,
        };
      }

      return null;
    },
    myanpayWalletDetails() {
      if (!this.isMyanpayDeposit || !this.pspPayment?.wallet_account) {
        return null;
      }

      return {
        account_name: this.pspPayment.wallet_account_name
          || this.pspPayment.account_name
          || this.pspPayment.bank_account_name
          || '',
        number: this.pspPayment.wallet_account,
      };
    },
    currentTime() {
      return moment(this.createDateWithTimeZone()).format('lll');
    },
  },
  async mounted() {
    this.fetchAccounts();
    this.fetchPromotions();
    const authUser = await this.fetchUser();
    if (!authUser) {
      this.$router.push('/auth/login');
    }
    if (authUser && !authUser.is_verified) {
      this.$router.push('/auth/verify');
    }
  },
};
</script>
<style scoped>
.finance-page .text-white {
  color: #334155 !important;
}

.psp-payment-panel__title {
  margin: 0 0 0.35rem;
  color: #714DC7 !important;
  font-size: 1.15rem;
  font-weight: 700;
  line-height: 1.3;
}

.psp-payment-panel__value {
  color: #8a69d9 !important;
  font-weight: 700;
}

.psp-payment-panel__value--break {
  word-break: break-all;
}

.number-container {
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #f8fafc;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0.25rem;
  padding-left: 0.85rem !important;
  padding-right: 0.85rem !important;
}

.psp-payment-panel .number-container {
  color: #64748b;
  font-size: 0.875rem;
  font-weight: 600;
}

.amount-cont {
  border: 1px solid #ccced0;
  border-radius: 10px;
}

.amount-cont.active {
  background: #dee2e6;
  color: black !important;
  border: 1px solid
}

.image-container {
  width: 200px;
  height: 200px;
}

.image-container img {
  width: 100%;
  height: 100%;
  border-radius: 5px;
}

.psp-payment-panel {
  border: 1px solid rgba(221, 77, 209, 0.35);
  border-radius: 16px;
  padding: 0.9rem 1rem;
  background: #fff;
  box-shadow: 0 8px 24px rgba(113, 77, 199, 0.1);
}

.psp-payment-panel .badge-danger {
  cursor: pointer;
  border-radius: 999px;
  padding: 0.35rem 0.7rem;
  font-size: 0.75rem;
  font-weight: 700;
  background: #fdf4fc !important;
  border: 1px solid #f0c4ea;
  color: #8a69d9 !important;
}

.psp-payment-panel .btn-outline-light {
  color: #8a69d9;
  border-color: #f0c4ea;
  background: #fdf4fc;
}

.psp-payment-panel .btn-outline-light:hover:not(:disabled),
.psp-payment-panel .btn-outline-light:focus:not(:disabled) {
  color: #714DC7;
  background: #eed1f6;
  border-color: #e89ae4;
}

.psp-payment-panel .text-warning {
  color: #b45309 !important;
  font-size: 0.8125rem;
  font-weight: 500;
}

.pending-pay-card {
  margin: 0.35rem 0 1rem;
  padding: 0.9rem;
  border-radius: 16px;
  background: #fff;
  border: 1px solid rgba(221, 77, 209, 0.35);
  box-shadow: 0 8px 24px rgba(113, 77, 199, 0.1);
}

.pending-pay-card__notice {
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
  margin-bottom: 0.9rem;
  padding: 0.7rem 0.8rem;
  border-radius: 12px;
  background: #fffbeb;
  border: 1px solid #fde68a;
}

.pending-pay-card__notice p {
  margin: 0;
  color: #92400e;
  font-size: 0.8125rem;
  font-weight: 500;
  line-height: 1.45;
}

.pending-pay-card__pulse {
  flex: 0 0 auto;
  width: 0.55rem;
  height: 0.55rem;
  margin-top: 0.28rem;
  border-radius: 50%;
  background: #f59e0b;
  box-shadow: 0 0 0 0 rgba(245, 158, 11, 0.55);
  animation: pending-pay-pulse 1.8s ease-out infinite;
}

.pending-pay-card__head {
  margin-bottom: 0.75rem;
}

.pending-pay-card__kicker {
  display: block;
  margin-bottom: 0.15rem;
  color: #64748b;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.02em;
}

.pending-pay-card__head h3 {
  margin: 0;
  color: #714DC7 !important;
  font-size: 1.15rem;
  font-weight: 700;
  line-height: 1.3;
}

.pending-pay-card__amount {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.35rem 0.75rem;
  margin-bottom: 0.85rem;
  padding: 0.85rem 1rem;
  border-radius: 14px;
  background: linear-gradient(135deg, #f179e2 0%, #DD4DD1 55%, #714DC7 100%);
  color: #fff;
}

.pending-pay-card__amount span {
  font-size: 0.8125rem;
  font-weight: 600;
  opacity: 0.9;
}

.pending-pay-card__amount strong {
  font-size: 1.45rem;
  font-weight: 800;
  letter-spacing: 0.01em;
  line-height: 1;
}

.pending-pay-card__amount small {
  margin-left: 0.2rem;
  font-size: 0.75rem;
  font-weight: 600;
  opacity: 0.85;
}

.pending-pay-card__rows {
  margin: 0;
}

.pending-pay-card__row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  grid-template-areas:
    "label copy"
    "value copy";
  align-items: center;
  column-gap: 0.75rem;
  row-gap: 0.1rem;
  padding: 0.7rem 0;
  border-top: 1px solid #e2e8f0;
}

.pending-pay-card__row dt {
  grid-area: label;
  margin: 0;
  color: #64748b;
  font-size: 0.75rem;
  font-weight: 600;
}

.pending-pay-card__row dd {
  grid-area: value;
  margin: 0;
  color: #0f172a;
  font-size: 1rem;
  font-weight: 700;
  word-break: break-word;
}

.pending-pay-card__digits {
  letter-spacing: 0.18em;
  font-variant-numeric: tabular-nums;
}

.pending-pay-card__copy {
  grid-area: copy;
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  min-height: 36px;
  padding: 0.3rem 0.7rem;
  border: 1px solid #f0c4ea;
  border-radius: 999px;
  background: #fdf4fc;
  color: #8a69d9;
  font-size: 0.75rem;
  font-weight: 700;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.pending-pay-card__copy:active {
  background: #eed1f6;
}

.pending-pay-card__cancel {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  width: 100%;
  min-height: 44px;
  margin-top: 0.85rem;
  padding: 0.6rem 1rem;
  border: 1px solid #fecaca;
  border-radius: 12px;
  background: #fff;
  color: #b91c1c;
  font-size: 0.875rem;
  font-weight: 700;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.pending-pay-card__cancel:active:not(:disabled) {
  background: #fef2f2;
}

.pending-pay-card__cancel:disabled {
  opacity: 0.6;
  cursor: default;
}

@keyframes pending-pay-pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(245, 158, 11, 0.5);
  }
  70% {
    box-shadow: 0 0 0 7px rgba(245, 158, 11, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(245, 158, 11, 0);
  }
}

.custom-file {
  height: auto;
}

@media (max-width: 768px) {
  .finance-page.main-wrapper {
    padding-top: 7px !important;
    padding-left: 7px !important;
    padding-right: 7px !important;
    padding-bottom: calc(8rem + env(safe-area-inset-bottom, 0px)) !important;
  }
}
</style>
